<template>
    <div id="user_download_guide">
        <div class="top_part">
            <img class="top-back-img" src="@/assets/user-guide/1.png" alt="">
            <button class="guide" @click="showGuideImg">点击查看解决方法</button>
            <button class="testflight" @click="downTestflight">点击下载 TestFlight</button>
        </div>
        <div class="middle-part">
            <img src="@/assets/user-guide/2.png" alt="">
            <img src="@/assets/user-guide/22.png" alt="">
            <!-- <button v-if="myCode" id="invite_down" >点击下载 金果子Pro</button>
            <button v-else @click="downIOS">点击下载 金果子Pro</button> -->
            <button @click="downIOS">点击下载 金果子Pro</button>
            <span class="copy my_code" @click="copy"></span>
        </div>
        <div v-show="guideShow" class="guide-part" @click="guideShow = false">
            <!-- <div class="img-box"> -->
                <button class="guide-btn des-file" @click.stop="downDes">下载描述文件</button>
                <!-- <button class="guide-btn speed">点击这里</button> -->
                <img class="first" src="@/assets/user-guide/3.png" alt="">
                <img class="second" src="@/assets/user-guide/4.png" alt="">
                <img class="third" src="@/assets/user-guide/5.png" alt="">
            <!-- </div> -->
        </div>
        <div id="mask" v-show="maskViewShow" @click="maskViewShow = false">
            <span class="mask-tip">请在浏览器中打开</span>
            <img src="@/assets/down/tip_arrow.png"/>
        </div>
        <div class="alert" v-show="alertShow">
            <span>{{message}}</span>
        </div>
    </div>
</template>

<script>
const Base64 = require('js-base64').Base64
import Clipboard from 'clipboard'
export default {
    name: 'UserDownloadGuide',
    data() {
        return {
            maskViewShow: false,
            guideShow: false,
            testFlightUrl: 'https://apps.apple.com/cn/app/testflight/id899247664',
            iosUrl: 'http://www.ggsign123.com/app_merge/jinguozi',
            ShareInstall: ShareInstall,
            message: '',
            alertShow: false,
            myCode: '',
            email: 'jinguozi007@gmail.com',
        }
    },
    mounted() {
        var isTest = this.$MyAxios.axiosInstance.defaults.baseURL == 'https://test.api.jinguozi.net' ? true : false;
        // this.iosUrl = isTest ? 'http://www.ggsign123.com/app_merge/jinguozi' : 'http://www.ggsign123.com/app_merge/jinguozi'
        var data = this.ShareInstall.parseUrlParams();//shareinstall.js中提供的工具函数，解析url中的所有查询参数
        // var self = this;
        // if(data.d){
        //     this.myCode = Base64.decode(data.d).split('_')[1];
        //     if(this.myCode){
        //         this.$nextTick(() => {
        //             new this.ShareInstall({
        //                 appKey : isTest ?  "KABK6HE72FEHRE" : "KRBK6HE72KBBK7",      //金果子PRO KEY
                    
        //                 /*可选参数，是否优先考虑拉起app，以牺牲下载体验为代价*/
        //                 preferWakeup:true,
        //                 /*可选参数，微信中直接跳下载*/
        //                 // weChatdownload:true,

        //                 // timeout: 10000,
        //                 onready : function() {
        //                     //shareinstall已成功回调
        //                     const m = this;
        //                     var inviteDownBtn = document.getElementById("invite_down");

        //                     //用户点击某个按钮时(假定按钮id为downloadButton)，安装app
        //                     inviteDownBtn.onclick = function() {
        //                         let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
        //                         if(isWeChat){
        //                             self.maskViewShow = true;
        //                             return
        //                         }
        //                         // alert('share-install')
        //                         m.wakeupOrInstall({downloadType: isTest ? 1 : 0});
        //                     }
        //                 }
        //             }, data);
        //         })
        //     }
            
        // }else{
        //     this.showAlert('缺少参数')
        // }
        this.getDownUrl();
    },
    watch: {
    },
    methods: {
        copy() {
            let str = this.email
            let clipboard = new Clipboard('.my_code', {
                text: function () {
                    return str
                }
            })
            console.log(clipboard)
            clipboard.on('success', e => {
                this.showAlert('复制成功')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.showAlert('复制失败，请长按邀请码进行复制')
                clipboard.destroy()
            })
        },
        getDownUrl() {
            this.$MyAxios.get('/api/versions/downloadUrl', {}, response => {
                if(response.code == 1) {
                    this.iosUrl = response.data.ios;
                }
            })
        },
        downTestflight() {
            window.location.href = this.testFlightUrl;
        },
        downIOS() {
            if(window._czc) {
                if(this.$route.meta.from === 'fxh') {
                    window._czc.push(['_trackEvent', '非小号', 'APP下载', 'iOS Testflight下载'])
                }else{
                    window._czc.push(['_trackEvent', 'APP下载', 'iOS下载'])
                }
            }
            // alert('test-flight')
            window.location.href = this.iosUrl;
        },
        showAlert(message) {
            this.message = message;
            this.alertShow = true;
            setTimeout(() => {
                this.alertShow = false;
            }, 1500);
        },
        showGuideImg() {
            this.guideShow = true
        },
        downDes() {
            window.open('https://www.chiruspace.com/xfapp.mobileconfig')
        },
        downSpeed() {
            window.open('https://www.chiruspace.com/xfapp.mobileconfig')
        }
    }
}
</script>

<style lang='less'>
#user_download_guide {
	height: auto;
	width: 100vw;
	background: #FFA41F;
	// padding-top: 38px;
	background-size: 100% 100%;
	background-repeat: no-repeat;
    position: relative;
    img {
        pointer-events: none;
    }

    button {
        height: 74px;
        width: 584px;
        outline: none;
        border: none;
        cursor: pointer;
        border-radius: 6px;
        background: #FFA41F;
        box-shadow:0px 6px 16px rgba(255,102,0,0.3);
        position: absolute;
        color: #ffffff;
        font-size: 32px;
        font-weight: bold;
        background: linear-gradient(to right, #ff7c0f , #ffa722);
    }
    .top_part {
        width: 100vw;
        height: 1034px;
        position: relative;
        .top-back-img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100vw;
        }
        button {
            left: 50%;
            transform: translateX(-50%);
            &.guide {
                top: 402px;
                background: #50C502;
                color: #ffffff;
            }
            &.testflight {
                top: 782px;
            }
        }
    }
    .middle-part {
        position: relative;
        img {
            width: 100vw;
        }
        button {
            top: 20px;
            left: 50%;
            transform: translateX(-50%);
        }
        margin-bottom: -5px;
        .copy {
            display: block;
            position: absolute;
            width: 50px;
            height: 50px;
            bottom: 80px;
            right: 80px;
        }
    }
    .guide-part {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        text-align: center;
        background: rgba(0, 0, 0, .6);
        padding-top: 5vw;
        img {
            width: 90vw;
            &.second {
                margin-top: -10px;
            }
            &.third {
                margin-top: -10px;
            }
        }
        .img-box {
            position: absolute;
            width: 90vw;
        }
        .guide-btn {
            width: auto;
            padding: 0 10px;
            height: 48px;
            background: linear-gradient(left,#ff8a00 0%, #ff5d00 100%);
            border-radius: 24px;
            box-shadow: 0px 3px 7px 0px rgba(255,105,0,0.35); 
            font-size: 24px;
            font-weight: normal;
        }
        .des-file {
            top: 552px;
            left: 230px;
            width: 180px;
        }
        .speed {
            bottom: 426px;
            left: 220px;
            width: 144px;
        }
    }
}
</style>
